import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LuLanguages } from "react-icons/lu";
// import { LuTruck } from "react-icons/lu";
import { IoCartOutline } from "react-icons/io5";
import { LuLogIn } from "react-icons/lu";
import { useSelector } from "react-redux";
import { FaRegUser } from "react-icons/fa6";
import TopBanner from "./TopBanner";
import axios from "axios";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";

function WebsiteNavbar({
  logo,
  setSearch,
  settings,
  setShowModalNav,
  handleLangChange,
  language,
}) {
  const customer = localStorage.getItem("rms-customer");

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [topBanner, setTopBanner] = useState();
  const [outlet, setOutlet] = useState(() =>
    JSON.parse(localStorage.getItem("rms-outlet"))
  );

  const cart = useSelector((state) => state.products.cart);

  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageUpdate = () => {
      const updatedOutlet = JSON.parse(localStorage.getItem("rms-outlet"));
      setOutlet(updatedOutlet);
    };

    window.addEventListener("storageUpdated", handleStorageUpdate);

    return () => {
      window.removeEventListener("storageUpdated", handleStorageUpdate);
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/topbanner`)
      .then((res) => {
        setTopBanner(res.data.data);
      })
      .catch((err) => {});
  }, []);
  return (
    <>
      <div className="w-full shadow-md pb-2 bg-white">
        {topBanner?.status === "active" && <TopBanner text={topBanner?.text} />}
        <div className="flex items-center max-w-7xl w-[90%] mx-auto pt-2">
          <div className="flex justify-between gap-x-4 items-center w-full">
            <div className="flex gap-4">
              <Link to={"/"} className="flex items-center gap-x-4">
                <img className="h-12 w-auto" src={logo} alt="" />
              </Link>
              <button
                className="text-start text-xs"
                onClick={() => setShowModalNav(true)}
              >
                <h2 className="text-gray-500">
                  {languageHelper("branch".toLowerCase()) || "Branch"}
                </h2>
                <p className="font-medium">{outlet?.outlet.name}</p>
              </button>
            </div>
            <div className="lg:flex items-center gap-x-4 hidden">
              <div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    navigate("/");
                  }}
                  className="bg-gray-200 flex items-center px-4 py-2 gap-x-2 rounded border"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    width="16"
                    viewBox="0 0 512 512"
                    className="fill-gray-400"
                  >
                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                  </svg>
                  <input
                    className="bg-transparent focus-within:outline-none"
                    placeholder={languageHelper("search") || "Search"}
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </form>
              </div>
              <div className="flex gap-x-2 text-sm">
                <div className="flex gap-x-6 font-medium text-w-heading">
                  {/* {settings?.add_to_cart === "active" && (
                    <Link
                      className="w-28 p-1 text-center flex gap-2 items-center"
                      to="/trackorder"
                    >
                      <LuTruck className="text-lg" />
                      <span>Track Order</span>
                    </Link>
                  )} */}
                  {settings?.add_to_cart === "active" && (
                    <hr className="w-[1px] h-full bg-gray-300" />
                  )}
                  <div className="relative">
                    <button
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                      className="w-28 p-1 text-center flex gap-2 items-center"
                    >
                      <LuLanguages className="text-lg" />
                      <span> {languageHelper("language") || "Language"} </span>
                    </button>
                    {dropdownOpen && (
                      <div className="absolute top-12 left-0 bg-white shadow-lg w-36 border rounded-lg p-1">
                        <ul>
                          <li>
                            <button
                              onClick={() => {
                                handleLangChange("text_en");
                                setDropdownOpen(false);
                              }}
                              className="w-full px-1 py-2 text-start hover:bg-gray-100 rounded"
                            >
                              {languageHelper("english") || "English"}
                            </button>
                          </li>
                          <hr />
                          <li>
                            <button
                              onClick={() => {
                                handleLangChange("text_ar");
                                setDropdownOpen(false);
                              }}
                              className="w-full px-1 py-2 text-start hover:bg-gray-100 rounded"
                            >
                              {languageHelper("arabic") || "Arabic"}
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                {settings?.add_to_cart === "active" && (
                  <Link
                    to={"mycart"}
                    className={`rounded w-24 p-1 text-w-btn-text flex items-center justify-center gap-2 relative bg-w-btn`}
                  >
                    {cart.length > 0 && (
                      <span className="bg-w-btn-text text-w-btn border border-w-border rounded-full text-xs absolute -top-1 -left-1 size-4 text-center">
                        {cart.length}
                      </span>
                    )}
                    <span>
                      <IoCartOutline className="text-w-btn-text text-2xl" />
                    </span>
                    <p>{languageHelper("cart") || "Cart"}</p>
                  </Link>
                )}
                {settings?.add_to_cart === "active" ? (
                  !customer ? (
                    <Link
                      to="/login"
                      className={`rounded text-center w-24 p-1 text-w-btn-text flex justify-center items-center gap-2 bg-w-btn`}
                    >
                      <span>
                        <LuLogIn className="text-w-btn-text text-2xl" />
                      </span>
                      <p>{languageHelper("login") || "Login"}</p>
                    </Link>
                  ) : (
                    <Link
                      to="/dashboard"
                      className={`rounded text-center py-1 px-2 text-w-btn-text bg-w-btn flex justify-center items-center gap-2`}
                    >
                      <span>
                        <FaRegUser className="text-w-btn-text text-lg" />
                      </span>
                      <p>{languageHelper("my account") || "My Account"}</p>
                    </Link>
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WebsiteNavbar;
